export default __webpack_public_path__ + "images/229a3a48a57bb7391594982ddc188322-directory_module.png";